import React from 'react';
import Icon from '../AppIcon';

const LocationCurrencyPrompt = ({
  visible,
  waiting,
  error,
  onAllow,
  onDismiss,
}) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] p-4 pb-24 sm:p-6 sm:pb-6 pointer-events-none">
      <div
        className="pointer-events-auto mx-auto max-w-lg rounded-2xl border border-border bg-card shadow-2xl overflow-hidden"
        role="dialog"
        aria-labelledby="location-currency-title"
        aria-describedby="location-currency-copy"
      >
        <div className="p-4 sm:p-5">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center">
              <Icon name="MapPin" size={20} />
            </div>
            <div className="min-w-0 flex-1">
              <h2 id="location-currency-title" className="text-base font-semibold text-foreground">
                Show prices in your currency?
              </h2>
              <p id="location-currency-copy" className="mt-1 text-sm text-muted-foreground leading-relaxed">
                Allow HireBroker to use your location so we can display prices in the
                currency of the country you are visiting from. We use this only to pick
                your local currency. You can change it anytime.
              </p>
              {error && (
                <p className="mt-2 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
                  {error}
                </p>
              )}
            </div>
          </div>
          <div className="mt-4 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
            <button
              type="button"
              onClick={onDismiss}
              disabled={waiting}
              className="px-4 py-2 rounded-lg border border-border text-sm font-medium text-foreground hover:bg-muted disabled:opacity-60"
            >
              Not now
            </button>
            <button
              type="button"
              onClick={onAllow}
              disabled={waiting}
              className="px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-semibold hover:opacity-90 disabled:opacity-60 inline-flex items-center justify-center gap-2"
            >
              <Icon name={waiting ? 'Loader2' : 'MapPin'} size={16} className={waiting ? 'animate-spin' : ''} />
              {waiting ? 'Waiting for permission…' : 'Allow location'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationCurrencyPrompt;
